import { useLocation } from 'react-router-dom'
import { isJSON } from 'utils/helper'

const useQueryParam = (key: string) => {
  const location = useLocation()
  const params = new URLSearchParams(location.search.substring(1))
  const val = params.get(key)

  if (val) {
    if (isJSON(val)) {
      return JSON.parse(val)
    }
    return val
  }

  return undefined
}

export default useQueryParam
